import { Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';
import { SignupComponent } from './core/components/signup/signup.component';
import { AuthenticatedGuard, canMatchPup, canMatchSupport, UnauthenticatedGuard } from './core/guards/auth.guard';
import { AppLayoutComponent } from './shared/components/layouts/app.layout.component';
import { NotfoundComponent } from './shared/components/notfound/not-found.component';
import { ForgotPasswordComponent } from './core/components/forgot-password/forgot-password.component';
import { CookieGuard } from './core/guards/cookie.guard';
import { companyOwnerGuard } from './features/ads/guards/company-owner.guard';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [UnauthenticatedGuard]
    },
    // {
    //     path: 'signup',
    //     component: SignupComponent,
    //     canActivate: [UnauthenticatedGuard]
    // },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        canActivate: [UnauthenticatedGuard]
    },
    {
        path: 'dashboard',
        component: AppLayoutComponent,
        canActivate: [AuthenticatedGuard, CookieGuard],
        children: [
            {
                path: '',
                loadChildren: () => import('./features/user/user-routing.module')
                    .then(m => m.UserRoutingModule),
            },
            {
                path: 'invoices',
                loadChildren: () => import('./features/invoices/invoices.routes')
                    .then(m => m.INVOICES_ROUTES),
            },
            {
                path: 'support',
                loadChildren: () => import('./features/supportUser/support-user-routing.module')
                    .then(m => m.SupportUserRoutingModule),
                canMatch: [canMatchSupport],
            },
            {
                path: 'pup',
                loadChildren: () => import('./features/pupUser/pup-user-routing.module')
                    .then(m => m.PupUserRoutingModule),
                canMatch: [canMatchPup]
            },
            {
                path: 'ads',
                loadChildren: () => import('./features/ads/ads-user.routes').then(m => m.routes),
                canMatch: [companyOwnerGuard]
            },
            {
                path: 'keys',
                loadChildren: () => import('./features/keys/keys.routes').then(m => m.KEYS_ROUTES),
            }
        ]
    },
   // Default Page
   { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
   { path: '**', component: NotfoundComponent }
];
